define(
    'plugins/musicfavourite/events',['./vendor', 'exports'],
    function(vendor, exports) {
        exports = new vendor.pubsub();

        return exports;
    }
);

